import { render } from "./ObservacionesTramite.vue?vue&type=template&id=ad13507a&scoped=true"
import script from "./ObservacionesTramite.vue?vue&type=script&lang=js"
export * from "./ObservacionesTramite.vue?vue&type=script&lang=js"

import "./ObservacionesTramite.vue?vue&type=style&index=0&id=ad13507a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad13507a"]])

export default __exports__